import { render, staticRenderFns } from "./NotAllowed.vue?vue&type=template&id=2d3762ee&scoped=true&"
import script from "./NotAllowed.vue?vue&type=script&lang=js&"
export * from "./NotAllowed.vue?vue&type=script&lang=js&"
import style0 from "./NotAllowed.vue?vue&type=style&index=0&id=2d3762ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3762ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
